<div class="not-found-container">
  <h1 class="custom-display-large">404</h1>
  <p class="custom-body-large">🌻 Die Seite, die Sie suchen, wurde nicht gefunden. 🌻</p>
  <button mat-flat-button class="button-emphasis" (click)="goHome()">Zur Startseite</button>
</div>